import { Big } from 'big.js';
import { TenantOrderLine } from '~/lib/model';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import MlmVirtualStagingConfig from './MlmVirtualStagingConfig';
import MlmJob from '../../model/MlmJob';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { DeliverableType } from '~common/model/Deliverable';

const MLM_VIRTUAL_STAGIN_PER_PHOTO_BASE_COST = 30;
const MLM_VIRTUAL_STAGIN_PER_PHOTO_DISCOUNT_COST = 25;

export default class MlmVirtualStagingJob extends MlmJob<typeof MlmVirtualStagingConfig> {
  get performable() {
    return MlmVirtualStagingConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MlmVirtualStagingConfig)['schema']> {
    return {
      photos: 1,
      version: schema_latest_version(MlmVirtualStagingConfig.schema),
    };
  }

  get deliverable() {
    return DeliverableType.PHOTO;
  }

  get eligible() {
    return true;
  }

  get configurable() {
    return true;
  }

  get media() {
    return PersonaType.EDITOR;
  }

  get input() {
    return {
      performables: [MlmPhotosConfig.id],
      required: this.metadata.photos,
      title: 'Select Staging Photos',
      description: 'choose which photos you would like virtually staged',
    };
  }

  revenueLines(): TenantOrderLine[] {
    const numberOfPhotos = this.metadata.photos;

    return [
      {
        amount:
          numberOfPhotos >= 5
            ? new Big(MLM_VIRTUAL_STAGIN_PER_PHOTO_DISCOUNT_COST).times(numberOfPhotos)
            : new Big(MLM_VIRTUAL_STAGIN_PER_PHOTO_BASE_COST).times(numberOfPhotos),
        discountable: false,
        description: this.performable.name,
        id: this.performable.id,
      },
    ];
  }
}
